import Nav from "./nav"
import Search from "./search"
import Form from "./form"
import Animation from "./animation"
import swiper from "./swiper"
import initMaps from "./maps"
import Tabs from "./tabs"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Form(jQuery)
    Animation(jQuery)
    swiper(jQuery)
    initMaps()
    Tabs(jQuery)
})
